import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsProjectComp from "./Component/TsProjectComp"


const TsProject =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsProjectComp />
        </div>
        <Footer />
        </>
    )
}

export default TsProject